/*
  central device manager, singleton
*/

import EventTarget from "eventtarget";

export default new (class Devices extends EventTarget {
  constructor(...args) {
    super(...args);
  }
  async connect() {
  }
  async disconnect() {    
  }    
})();